/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import { Button } from './Button';
import styles from './PageActions.styles';
import registerDefaults from './themeDefaults';

registerDefaults();
const useStyles = createUseStyles(styles);

const PageActions = (props) => {
  const classes = useStyles(props);
  const { actions } = props;
  return (
    <div className={classes.root}>
      {actions.map((action, index) => (
        <div key={`pageaction-${index}`} className={classes.action}>
          <Button className={classes.button} {...action} />
        </div>
      ))}
    </div>
  );
};

PageActions.propTypes = {
  /** Array of actions for button menu */
  actions: PropTypes.arrayOf(PropTypes.shape({
    /** function to call on click of button */
    onClick: PropTypes.func,
    /** text of button */
    text: PropTypes.string
  })).isRequired
};

export default PageActions;
